export default (val) => {
  return `${val}`.replace(/\./g, ',');
};
